import { createContext, use } from 'react'
import type { Municipio, TipoDeuda } from '@/api/modelos'

/** El municipio de la URL, ya comprobado contra los del usuario. */
const ContextoMunicipio = createContext<Municipio | null>(null)

export const ProveedorMunicipio = ContextoMunicipio.Provider

export function useMunicipioActual(): Municipio {
  const municipio = use(ContextoMunicipio)

  if (municipio === null) {
    throw new Error('useMunicipioActual solo funciona dentro de una ruta /m/:municipio')
  }

  return municipio
}

/**
 * Lo que el servidor da por defecto (Company::TIPOS_POR_DEFECTO), para una
 * sesion guardada antes de que el municipio trajera `tipos`.
 */
const TIPOS_POR_DEFECTO: readonly TipoDeuda[] = ['aseo', 'patente']

/** Los tipos de deuda que cobra un municipio: el panel ofrece solo estos. */
export function tiposDelMunicipio(municipio: Municipio | null): readonly TipoDeuda[] {
  return municipio?.tipos?.length ? municipio.tipos : TIPOS_POR_DEFECTO
}

/** Los del municipio de la URL; fuera de una ruta de municipio, los por defecto. */
export function useTiposDelMunicipio(): readonly TipoDeuda[] {
  return tiposDelMunicipio(use(ContextoMunicipio))
}
